import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class default_1 extends Vue {
    fullscreen;
    value = '';
    // get name() {
    //   return UserModule.name
    // }
    // get roles() {
    //   return UserModule.roles
    // }
    get imgSrc() {
        const res = this.fullscreen ? require('@blade/common/assets/svgs/narrow.svg') : require('@blade/common/assets/svgs/enlarge.svg');
        return res;
    }
    handleCreate() {
        this.$emit('onOpenCreate');
    }
    handleFullScreen() {
        this.$emit('onFullScreen');
    }
    handleRefresh() {
        this.$emit('onRefresh');
    }
};
__decorate([
    Prop({})
], default_1.prototype, "fullscreen", void 0);
default_1 = __decorate([
    Component({
        name: 'organizationHeader',
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    roleLists: 'Role Lists',
                    create: 'Create',
                },
                zh: {
                    roleLists: '组织列表',
                    create: '创建',
                },
            },
        },
    })
], default_1);
export default default_1;
